const PRACTICE_CONFIGS = {
    "carolina-omf": {
        practice_name: "Carolina OMF Imaging",
        practitioner_name: "Dr. Colvin",
        contact_email: "ncolvin@carolinaomfimaging.com",
    },
    "doctor-office-one": {
        practice_name: "Doctor Office One",
        practitioner_name: "Dr. Smith",
        contact_email: "referrals@doctorofficeone.com",
    },
};

export default PRACTICE_CONFIGS;
